import { FC, useState } from 'react';

import classNames from 'classnames';

import { Button } from '../../shared/ui';
import { useAppSelector } from '../../hooks/redux';
import { EmoView } from '../tools/detector-emo/emo-view';

export const Reactions: FC<{
  sendEmotionsSelect?: (result: { category: string[]; emo: string[] }) => void;
  /** Мобильный 1:1 на весь экран: заголовок в верхней полосе сцены, компактные эмоции, «Выбрать» закреплена внизу */
  mobile?: boolean;
}> = ({ sendEmotionsSelect, mobile = false }) => {
  const psyTools = useAppSelector((state) => state.psyToolsSlice.tools);
  const [reactionId, setReactionId] = useState<string[]>([]);
  const [selectedEmo, setSelectedEmo] = useState<string[]>([]);
  const [selectionFinished, setSelectionFinished] = useState(false);

  const settings = psyTools.find((el) => el.name === 'emotions_detection')?.psy_tool_settings;
  const handleSelect = () => {
    if (!reactionId) return;

    const payload = {
      category: reactionId,
      emo: selectedEmo,
    };

    sendEmotionsSelect?.(payload);
    setSelectionFinished(true);
  };

  if (mobile) {
    if (selectionFinished) {
      return (
        <div className="flex h-full min-h-0 w-full flex-col bg-ink-muted px-4 pb-4 pt-1">
          <p className="mb-3 text-ui text-white/80">Ваш выбор отправлен психологу</p>
          <div className="min-h-0 flex-1 overflow-y-auto white-scroll">
            <div className="flex flex-wrap gap-2">
              {selectedEmo.map((el) => (
                <span key={el} className="rounded-full bg-black/20 px-3 py-1.5 text-ui font-medium text-white">
                  {el}
                </span>
              ))}
            </div>
          </div>
        </div>
      );
    }

    const toggleEmotion = (item: string, selected: string[]) => {
      setSelectedEmo(selected.includes(item) ? selected.filter((el) => el !== item) : [...selected, item]);
    };

    return (
      <div className="flex h-full min-h-0 w-full flex-col bg-ink-muted px-4 pt-1">
        <p className="shrink-0 pb-3 text-ui text-white/80">
          Выберите категорию и отметьте эмоции, которые вы сейчас испытываете.
        </p>
        <div className="min-h-0 flex-1 overflow-y-auto pb-3 white-scroll">
          <EmoView
            mobile
            settings={settings}
            selectedEmo={selectedEmo}
            onEmotionClick={toggleEmotion}
            reactionId={reactionId}
            setReactionId={setReactionId}
          />
        </div>
        <div className="shrink-0 border-t border-white/10 pb-3 pt-3">
          <Button size="lg" fullWidth disabled={selectedEmo.length === 0} onClick={() => handleSelect()}>
            {selectedEmo.length > 0 ? `Выбрать (${selectedEmo.length})` : 'Выберите эмоции'}
          </Button>
        </div>
      </div>
    );
  }

  if (selectionFinished) {
    return (
      <div className="w-full h-full pr-[0.25rem] ">
        <div
          className={classNames(
            'w-full h-full bg-ink-muted md:rounded-card p-3.5 md:p-4 relative flex flex-col justify-between ',
            {
              // Both: `md:p-4` comes later in the CSS than a plain `pr-*`.
              'pr-[11px] md:pr-[11px]': reactionId,
            },
          )}
        >
          <div className="w-full flex md:flex-col flex-wrap overflow-y-auto white-scroll gap-[15px] md:items-center">
            {selectedEmo.map((el, idx) => (
              <div
                className="w-full max-w-[240px] 2xl:max-w-[360px] bg-ink/60 rounded-chip py-[2px] px-0 lg:p-[5px_10px] text-center text-body-l-strong text-white mx-auto"
                key={idx}
              >
                {el}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
  const onEmotionClick = (item: string, selected: string[]) => {
    if (selected.includes(item)) {
      setSelectedEmo([...selected.filter((el) => el !== item)]);
    } else {
      setSelectedEmo([...selected, item]);
    }
  };

  return (
    <div className="w-full h-full pr-[0.25rem]">
      <div className="w-full h-full flex flex-col rounded-chip md:rounded-card bg-ink-muted justify-between">
        <div className="w-full h-full max-h-full scroll-white overflow-y-auto p-[2rem]">
          <EmoView
            settings={settings}
            selectedEmo={selectedEmo}
            onEmotionClick={onEmotionClick}
            reactionId={reactionId}
            setReactionId={setReactionId}
          />
        </div>

        <div className="mt-auto w-full max-w-[222px] xl:mb-4 flex justify-center mx-auto  p-[0.3rem]">
          <Button
            size="md"
            variant="primary"
            fullWidth
            disabled={selectedEmo.length === 0}
            onClick={() => handleSelect()}
          >
            Выбрать
          </Button>
        </div>
      </div>
    </div>
  );
};
